/*
 * File: addressesFiltersSlice.ts
 * Project: rosita
 * -----
 * Last Modified: 25 Feb 2022 1:16:44 am
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetAddressesParams, LocationAddressTypes } from './models/addresses';

const initialState: GetAddressesParams = {
  offset: 0,
  orderByField: undefined,
  orderByDirection: undefined,
  addressCodeContains: undefined,
  addressNameContains: undefined,
  addressTypesInclude: [LocationAddressTypes.Delivery, LocationAddressTypes.Install, LocationAddressTypes.Warehouse],
  street1Contains: undefined,
  cityContains: undefined,
  countyContains: undefined,
  countryAlpha2CodeEquals: undefined,
  subdivisionLocalCodeEquals: undefined,
  postalCodeContains: undefined,
  returnDeletedDataOnly: undefined,
  includeDeletedData: undefined,
  take: undefined,
  locationIdEquals: undefined,
  warehouseTypeEquals: undefined
};

export const chuckieSueAddressesParams = createSlice({
  name: 'chuckieSueAddressesParams',
  initialState,
  reducers: {
    setOffset: (state, { payload }: PayloadAction<GetAddressesParams['offset']>) => {
      state.offset = payload;
    },
    incrementOffset: (state) => {
      state.offset += 25;
    },
    setAddressCodeContains: (state, { payload }: PayloadAction<GetAddressesParams['addressCodeContains']>) => {
      state.addressCodeContains = payload;
      state.offset = 0;
    },
    setAddressNameContains: (state, { payload }: PayloadAction<GetAddressesParams['addressNameContains']>) => {
      state.addressNameContains = payload;
      state.offset = 0;
    },
    setAddressTypesInclude: (state, { payload }: PayloadAction<GetAddressesParams['addressTypesInclude']>) => {
      state.addressTypesInclude = payload;
      state.offset = 0;
    },
    setStreet1Contains: (state, { payload }: PayloadAction<GetAddressesParams['street1Contains']>) => {
      state.street1Contains = payload;
      state.offset = 0;
    },
    setCityContains: (state, { payload }: PayloadAction<GetAddressesParams['cityContains']>) => {
      state.cityContains = payload;
      state.offset = 0;
    },
    setCountyContains: (state, { payload }: PayloadAction<GetAddressesParams['countyContains']>) => {
      state.countyContains = payload;
      state.offset = 0;
    },
    setCountryAlpha2CodeEquals: (state, { payload }: PayloadAction<GetAddressesParams['countryAlpha2CodeEquals']>) => {
      state.countryAlpha2CodeEquals = payload;
      state.offset = 0;
    },
    setSubdivisionLocalCodeEquals: (state, { payload }: PayloadAction<GetAddressesParams['subdivisionLocalCodeEquals']>) => {
      state.subdivisionLocalCodeEquals = payload;
      state.offset = 0;
    },
    setPostalCodeContains: (state, { payload }: PayloadAction<GetAddressesParams['postalCodeContains']>) => {
      state.postalCodeContains = payload;
      state.offset = 0;
    },
    setLocationIdEquals: (state, { payload }: PayloadAction<GetAddressesParams['locationIdEquals']>) => {
      state.locationIdEquals = payload;
      state.offset = 0;
    },
    setWarehouseTypeEquals: (state, { payload }: PayloadAction<GetAddressesParams['warehouseTypeEquals']>) => {
      state.warehouseTypeEquals = payload;
      state.offset = 0;
    },
    resetParams: (state) => {
      Object.assign(state, initialState);
    }
  }
});

export const {
  setOffset,
  incrementOffset,
  setAddressCodeContains,
  setAddressNameContains,
  setAddressTypesInclude,
  setCityContains,
  setCountryAlpha2CodeEquals,
  setCountyContains,
  setPostalCodeContains,
  setStreet1Contains,
  setSubdivisionLocalCodeEquals,
  setLocationIdEquals,
  resetParams,
  setWarehouseTypeEquals
} = chuckieSueAddressesParams.actions;
